import { LOAD } from "./action";

const initialState = {
  loadList: [],
  loadCreated: {},
  selectedLoad: {},
  loadUpdated: {}
};

export default function loadReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD.list.success:
      return {
        ...state,
        loadList: action.data,
        loadCreated: {},
        loadUpdated: {}
      };
    case LOAD.create.success:
      return {
        ...state,
        loadCreated: action.data
      };
    case LOAD.edit.success:
      return {
        ...state,
        selectedLoad: action.data
      };
    case LOAD.update.success:
      return {
        ...state,
        loadUpdated: action.data
      };
    case LOAD.delete.success:
      const loadId = action.data.id;
      return {
        ...state,
        loadList: state.loadList.filter(load => load.id !== loadId)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/loadnoindicator/reducer.js